import React from "react";
import styled from "styled-components";

const Container = styled.div`
    padding: 0;
    margin: 0;
    width: ${({subCellWidth}) => subCellWidth}px;
    border-right: ${({index, count}) => index != count ? "0.5px solid lightgrey" : "none"};
    height: 100%;
    display: inline-block;
`;

const SingleCellDiv = ({
    subCellWidth,
    index,
    count,
    onClick
}) => (
        <Container
            subCellWidth={subCellWidth}
            index={index}
            count={count}
            onClick={onClick}
        />
)

export default SingleCellDiv
